import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { errors, fallbacks, layouts, pages } from './imports';

export function transformElegantRoutesToReactRoutes(routes: any[]) {
  return routes.flatMap(route => transformElegantRouteToReactRoute(null, route));
}

const concatPath = (prefix: string | undefined | null, path: string | null | undefined) => {
  if (!path) path = '';
  if (prefix) {
    prefix = prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
    path = path.startsWith('/') ? path.slice(1) : path;
    return `${prefix}/${path}`;
  }
  return path;
};

export function transformElegantRouteToReactRoute(parent: any, route: any): RouteObject {
  const {
    children,
    component,
    errorBoundary,
    fallback,
    handle,
    name, // M. 目录 C.菜单 A.按钮
    path,
    redirect,
    type
  } = route;
  const fullPath = concatPath(parent?.fullPath, path);

  const getErrorComponent = errors[errorBoundary || 'default'];

  function convertConfig(m: any) {
    const { action, default: Component, loader, shouldRevalidate } = m;
    return {
      action,
      Component,
      loader,
      shouldRevalidate
    };
  }

  async function getConfig() {
    if (component) {
      // debugger;
      const config = await (type === 'M'
        ? layouts[component]()
        : pages[concatPath('/src/pages', `${component}.tsx`)]());
      return convertConfig(config);
    }
    return null;
  }

  function getHandle() {
    return handle;
  }
  const reactRoute = {
    children: [],
    fullPath,
    handle: getHandle(),
    HydrateFallback: fallbacks[fallback || 'default'],
    id: name,
    lazy: async () => {
      const ErrorBoundary = await getErrorComponent();
      return {
        ErrorBoundary: ErrorBoundary?.default,
        ...(await getConfig())
      };
    }
  } as RouteObject;

  if (path) {
    reactRoute.path = path;
  }

  if (children?.length) {
    reactRoute.children = children.flatMap((child: any) => transformElegantRouteToReactRoute(reactRoute, child));

    if (redirect) {
      (reactRoute.children as any[]).unshift({
        Component: () => (
          <Navigate
            replace
            to={redirect}
          />
        ),
        handle: {},
        index: true
      });
    }
  }

  return reactRoute;
}
